import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

import * as api from "@/api/vuln-tracker/detectedManagedNode";
import * as translation from "@/api/vuln-tracker/translation";
import {
  enableTranslation,
  CVETranslationResult,
  RequestPagination,
  SearchCriteriaItem,
  DetectedManagedNodeItem,
  emptySearchCriteria,
  duplicateSearchCriteria,
} from "@/libs/vulnUtil";
import { VulnTrackerCommonModule } from "@/store/modules/vuln-tracker/common";

@Module({
  dynamic: true,
  store,
  name: "vulnTracker.DetectedManagedNode",
  namespaced: true,
})
export class DetectedManagedNode extends VuexModule {
  itemList: DetectedManagedNodeItem[] = [];
  total: number = 0;
  loading: boolean = false;
  error: string | null = null;
  title: CVETranslationResult[] = [];

  pageState: {
    currentPage: number;
    criteria: SearchCriteriaItem;
  } = {
    currentPage: 1,
    criteria: emptySearchCriteria(),
  };

  enableTranslation: boolean = enableTranslation("detectedManagedNode");

  @Mutation
  SetItemList(payload: DetectedManagedNodeItem[]) {
    this.itemList = payload;
  }

  @Mutation
  SetTotal(payload: number) {
    this.total = payload;
  }

  @Mutation
  SetItemListLoading(payload: boolean) {
    this.loading = payload;
  }

  @Mutation
  SetItemListError(payload: string | null) {
    this.error = payload;
  }

  @Mutation
  SetCurrentPage(payload: number) {
    this.pageState.currentPage = payload;
  }

  @Mutation
  SetCriteria(payload: SearchCriteriaItem) {
    this.pageState.criteria = duplicateSearchCriteria(payload);
  }

  @Mutation
  ResetPageState() {
    this.pageState.currentPage = 1;
    this.pageState.criteria = emptySearchCriteria();
  }

  @Mutation
  ClearItemList() {
    this.itemList = [];
  }

  @Action({ rawError: true })
  async getList(payload: { pagination: RequestPagination }) {
    this.SetItemListLoading(true);

    await api
      .getList({
        pagination: payload.pagination,
        criteria: this.pageState.criteria,
      })
      .then((res) => {
        this.SetItemList(res.managed_nodes);
        this.SetTotal(res.pagination.total);
      })
      .catch((err) => {
        this.ClearItemList();
        this.SetItemListError(err);
        VulnTrackerCommonModule.AddApiError({
          target: "検知端末一覧取得",
          message: err,
        });
      });

    this.SetItemListLoading(false);
  }

  @Action({ rawError: true })
  async translate(index: number) {
    if (this.enableTranslation) {
      const vulns = this.itemList[index].vulnerabilities;
      for (let i = 0; i < vulns.length; i++) {
        const vuln = vulns[i];
        const cveId = vuln.cve_id;
        const title = vuln.title;
        if (cveId != null && title != null) {
          const index = this.title.findIndex((result) => result.cveId == cveId);
          if (index < 0 || this.title[index].result.text != title) {
            await translation
              .translate(title)
              .then((res) => {
                if (index >= 0) {
                  this.title.splice(index, 1);
                }
                this.title.push({
                  cveId: cveId,
                  result: {
                    text: title,
                    translatedText: res.data.translations[0].translatedText,
                  },
                });
              })
              .catch(() => {});
          }
        }
      }
    }
  }
}

export const DetectedManagedNodeModule = getModule(DetectedManagedNode);
